import { useContext } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Breadcrumbs as FoundationsBreadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import { Link } from 'foundations-components/transitional/components/Link';
import { useEditorActions } from '../../../../hooks/useEditorActions';
import SegmentationFiltersInstanceContext from '../../../../state/SegmentationFiltersInstanceContext';
import { categoryOptions, CATEGORY_KEYS, isCategoryKey } from '../../categorySelection/Categories';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Breadcrumbs = ({
  locationLabel
}) => {
  const {
    selectedCategory,
    selectedFilterFamilyGroup
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    resetFilterCategorySelect
  } = useEditorActions();
  if (!isCategoryKey(selectedCategory)) {
    return null;
  }
  const categoryOption = categoryOptions[selectedCategory];
  if (!categoryOption || selectedCategory === CATEGORY_KEYS.PROPERTIES || !locationLabel) {
    return null;
  }
  return /*#__PURE__*/_jsxs(FoundationsBreadcrumbs, {
    flush: true,
    marginInline: "400",
    marginBlockStart: "400",
    marginBlockEnd: "0",
    children: [/*#__PURE__*/_jsx(Link, {
      onClick: () => resetFilterCategorySelect(!!selectedFilterFamilyGroup),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: categoryOption.messageKey
      })
    }), /*#__PURE__*/_jsx("span", {
      children: locationLabel
    })]
  });
};
export default Breadcrumbs;